// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2586":"11c5b3d1","4798":"11c5b3d1","5360":"11c5b3d1","7553":"11c5b3d1"}[chunkId] + ".chunk.css";
};